(() => {
  if (!customElements.get("echo-slider")) {
    class echoSlider extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        const slider = this.querySelector(".swiper");

        const slidesPerView = this.getAttribute("data-slide-per-row");
        const spaceBetween = this.getAttribute("data-space-between");
        const showDots = this.getAttribute("data-show-dots");
        const showArrows = this.getAttribute("data-show-arrows");

        const mobileSlidesPerView = this.getAttribute(
          "data-mobile-slide-per-row"
        );

        const swiperOptions = {
          slidesPerView: mobileSlidesPerView,
          spaceBetween: spaceBetween,
          effect: "fade",
          fadeEffect: {
              crossFade: true
            },
          loop: false,
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: spaceBetween,
            },
            768: {
              slidesPerView: slidesPerView,
              spaceBetween: spaceBetween,
            },
          },
        };

        // Check if data-show-dots is set to 'yes', if so, include pagination options
        if (showDots === "yes") {
          swiperOptions.pagination = {
            el: ".swiper-pagination",
            clickable: true,
          };
        }

        // Check if data-show-dots is set to 'yes', if so, include pagination options
        if (showArrows === "yes") {
          swiperOptions.navigation = {
            nextEl: ".slider-button-next",
            prevEl: ".slider-button-prev",
          };
        }

        const swiper = new Swiper(slider, swiperOptions);
      }

      connectedCallback() {
        this.init();
      }
    }
    customElements.define("echo-slider", echoSlider);
  }
})();
